import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import styled from 'styled-components'

import type { components } from '../../../constants/schema'

import { Text } from '../../../components/text'
import { FOOTER_MIN_HEIGHT } from '../../../components/footer'

import { Color } from '../../../theme/color'

interface FooterNotifyProps {
  activeProductSale?: components['schemas']['ProductDetailDto']['activeProductSale']
  overallStatus?: components['schemas']['ProductDetailDto']['overallStatus']
}

const FooterNotify = ({ activeProductSale, overallStatus }: FooterNotifyProps) => {
  const [date, setDate] = useState<string>('')
  const [isFinish, setIsFinish] = useState<boolean>(false)

  useEffect(() => {
    const statusDate = () => {
      switch (overallStatus) {
        case 'SALE_TO_BE_RELEASED':
          return activeProductSale?.releaseDate
        case 'SALE_RELEASE':
          return activeProductSale?.untilDate
        default:
          return activeProductSale?.createdDate
      }
    }

    const getTimes = (date: string) => {
      const day = dayjs(date).subtract(9, 'hour').diff(dayjs(), 'day')
      const hour = dayjs(date).subtract(9, 'hour').diff(dayjs(), 'hour') % 24
      const minute = dayjs(date).subtract(9, 'hour').diff(dayjs(), 'minute') % 60
      const second = dayjs(date).subtract(9, 'hour').diff(dayjs(), 'second') % 60
      return `${day}일 ${hour}:${minute}:${second}`
    }

    const countDate = setInterval(() => {
      const nowDate = dayjs().add(9, 'hour')

      if (
        (overallStatus === 'SALE_RELEASE' || overallStatus === 'SALE_FINISH') &&
        dayjs(statusDate()).diff(nowDate) < 0
      ) {
        clearInterval(countDate)
        setIsFinish(true)
        return
      }

      if (overallStatus === 'SALE_TO_BE_RELEASED') {
        const releaseDate = dayjs(statusDate())
        setDate(getTimes(releaseDate.toString()))
      }
      if (overallStatus === 'SALE_RELEASE') {
        const untilDate = dayjs(statusDate())
        if (untilDate.diff(dayjs()) < 0) {
          clearInterval(countDate)
          setIsFinish(true)
          return
        }
        setDate(getTimes(untilDate.toString()))
      }
    }, 1000)

    return () => {
      clearInterval(countDate)
    }
  }, [activeProductSale, overallStatus])

  if (!overallStatus || !activeProductSale || (!date && !isFinish)) {
    return <></>
  }

  if (isFinish || overallStatus === 'SALE_FINISH') {
    return (
      <FooterNotice>
        <Text size={14}>청약이 마감되었어요.</Text>
      </FooterNotice>
    )
  }

  return (
    <FooterNotice>
      {overallStatus === 'SALE_TO_BE_RELEASED' && (
        <Text size={14}>
          시작까지{' '}
          <Text size={14} weight={600} color="error">
            {date}
          </Text>{' '}
          남았어요!
        </Text>
      )}
      {overallStatus === 'SALE_RELEASE' && (
        <>
          <Text size={14}>
            마감까지{' '}
            <Text size={14} weight={600} color="error">
              {date}
            </Text>{' '}
            남았어요!
          </Text>
        </>
      )}
    </FooterNotice>
  )
}

export default FooterNotify
export type { FooterNotifyProps }

const FooterNotice = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: absolute;
  bottom: calc(env(safe-area-inset-bottom) + ${FOOTER_MIN_HEIGHT}px);
  left: 0;
  width: 100%;
  height: 33px;
  padding: 0 16px;
  background-color: ${Color.primary_2};
`
